import { CityAttractionArtifactRO } from '@routellers/types/dist/city-attraction/city-attraction-artifact.ro';
import { AttractionArtifactKindEnum } from '@routellers/types/dist/city-attraction/enum/attraction-artifact-kind.enum';
import { UpsertCityAttractionArtifactDto } from '@routellers/types/dist/city-attraction/upsert-city-attraction-artifact.dto';

export const emptyArtifact = (sortOrder = 0): UpsertCityAttractionArtifactDto => ({
    kind: AttractionArtifactKindEnum.ARTWORK,
    title: '',
    description: '',
    knownFor: '',
    findHint: '',
    personId: null,
    wikidataId: null,
    photos: [],
    sortOrder,
    archived: false,
});

export const artifactsFromRo = (
    list?: CityAttractionArtifactRO[],
): UpsertCityAttractionArtifactDto[] =>
    (list || [])
        .slice()
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
        .map((a) => ({
            id: a.id,
            kind: a.kind,
            title: a.title,
            description: a.description,
            knownFor: a.knownFor,
            findHint: a.findHint,
            personId: a.personId,
            wikidataId: a.wikidataId,
            photos: a.photos || [],
            sortOrder: a.sortOrder,
            archived: a.archived,
            titles: a.titles,
        }));
